import * as RestClient from '../../utils/rest-service';
import Constants from '../../config/constants';

export const ACTION = {
  LIST: 'LIST_PROJECT_LOCATION',
};

export const searchProjectLocation = (pageSize, page, sorted, filtered, isPublic) => {
  return RestClient.request({
    method: 'get',
    url: `${Constants.API_PROJECT}map/`,
    params: {
      search: filtered,
      limit: pageSize,
      offset: pageSize * page,
      ordering: sorted
        ? sorted.map(sort => sort.desc ? `-${sort.id}` : sort.id).join(',')
        : null,
      is_public: isPublic,
    },
  });
};

export const listProjectLocation = (pageSize, page, sorted, filtered, isPublic) => {
  return {
    type: ACTION.LIST,
    payload: searchProjectLocation(pageSize, page, sorted, filtered, isPublic)
      .then(data => ({ data }))
      .catch(err => Promise.reject(err.response.data.detail)),
  };
};



// WEBPACK FOOTER //
// ./src/redux/projects/project_location_actions.js